import { render, staticRenderFns } from "./AzSubTitle.vue?vue&type=template&id=4a08c869&scoped=true&"
import script from "./AzSubTitle.vue?vue&type=script&lang=js&"
export * from "./AzSubTitle.vue?vue&type=script&lang=js&"
import style0 from "./AzSubTitle.vue?vue&type=style&index=0&id=4a08c869&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a08c869",
  null
  
)

export default component.exports